import Vue from 'vue'

Vue.filter('removeQuotes', function(text) {
  if (text) {
    return text.replace(/['"]+/g, '')
  }
  return text
})
